export const fieldsRotas = [
    // Campos da rota
    { label: 'Início da rota', value: 'ROTA_INICIO', selected: false },
    { label: 'Fim da rota', value: 'ROTA_FIM', selected: false },
    { label: 'Data da rota', value: 'ROTA_DATA', selected: false },
    { label: 'Nome da rota', value: 'ROTA_NOME', selected: false },
    { label: 'Identificador da rota', value: 'ROTA_IDENTIFICADOR', selected: false },
    { label: 'Tipo de veículo', value: 'ROTA_TIPO_VEICULO', selected: false },
    { label: 'Placa do veículo', value: 'ROTA_PLACA', selected: false },
    { label: 'Nome do motorista', value: 'ROTA_NOME_MOTORISTA', selected: false },
    { label: 'Ativa', value: 'ROTA_ATIVA', selected: false },
    { label: 'Tem escolta', value: 'ROTA_TEM_ESCOLTA', selected: false },
    { label: 'Permite carga expressa', value: 'ROTA_PERMITE_CARGA_EXPRESSA', selected: false },
    { label: 'Peso', value: 'ROTA_PESO', selected: false },
    { label: 'Volume', value: 'ROTA_VOLUME', selected: false },
    { label: 'Cubagem', value: 'ROTA_CUBAGEM', selected: false },
    { label: 'Valor', value: 'ROTA_VALOR', selected: false },
    { label: 'Distância planejada', value: 'ROTA_DISTANCIA_PLANEJADA', selected: false },
    { label: 'Distância executada', value: 'ROTA_DISTANCIA_EXECUTADA', selected: false },
    { label: 'Tempo planejado', value: 'ROTA_TEMPO_PLANEJADO', selected: false },
    { label: 'Tempo executado', value: 'ROTA_TEMPO_EXECUTADO', selected: false },
    { label: 'POIs planejados', value: 'ROTA_POIS_PLANEJADOS', selected: false },
    { label: 'POIs executados', value: 'ROTA_POIS_EXECUTADOS', selected: false },
    { label: 'Visitas adiadas', value: 'ROTA_VISITAS_ADIADAS', selected: false },
    { label: 'Visitas adicionadas', value: 'ROTA_VISITAS_ADICIONADAS', selected: false },
    { label: 'Visitas canceladas', value: 'ROTA_VISITAS_CANCELADAS', selected: false },
    { label: 'Visitas com ocorrência', value: 'ROTA_VISITAS_OCORRENCIA', selected: false },
    { label: 'Visitas pendentes', value: 'ROTA_VISITAS_PENDENTES', selected: false },
    { label: 'Visitas com sucesso', value: 'ROTA_VISITAS_SUCESSO', selected: false },
    { label: 'Código do Veículo', value: 'ROTA_CODIGO_VEICULO', selected: false },
    { label: 'Custo do KM', value: 'ROTA_CUSTO_KM', selected: false },
    { label: 'Custo Planejado', value: 'ROTA_CUSTO_PLANEJADO', selected: false },
    { label: 'Custo Executado', value: 'ROTA_CUSTO_EXECUTADO', selected: false },

    // Campos de visitas
    { label: 'Código da visita', value: 'VISITA_CODIGO', selected: false },
    { label: 'Latitude da visita', value: 'VISITA_LATITUDE', selected: false },
    { label: 'Longitude da visita', value: 'VISITA_LONGITUDE', selected: false },
    { label: 'Cliente da visita', value: 'VISITA_CLIENTE', selected: false },
    { label: 'Status da visita', value: 'VISITA_STATUS', selected: false },
    { label: 'Tempo de parada', value: 'VISITA_TEMPO_PARADA', selected: false },
    { label: 'Diferença de chegada', value: 'VISITA_DIFERENCA_CHEGADA', selected: false },
    { label: 'Diferença de partida', value: 'VISITA_DIFERENCA_PARTIDA', selected: false },
    { label: 'Tipo de visita', value: 'VISITA_TIPO', selected: false },
    { label: 'Endereço da visita', value: 'VISITA_ENDERECO', selected: false },
    { label: 'Carga expressa', value: 'VISITA_CARGA_EXPRESSA', selected: false },
    { label: 'Alto valor agregado', value: 'VISITA_ALTO_VALOR_AGREGADO', selected: false },
    { label: 'Filial', value: 'VISITA_FILIAL', selected: false },
    { label: 'Chegada planejada', value: 'VISITA_CHEGADA_PLANEJADA', selected: false },
    { label: 'Chegada executada', value: 'VISITA_CHEGADA_EXECUTADA', selected: false },
    { label: 'Partida planejada', value: 'VISITA_PARTIDA_PLANEJADA', selected: false },
    { label: 'Partida executada', value: 'VISITA_PARTIDA_EXECUTADA', selected: false },
    { label: 'Ordem planejada', value: 'VISITA_ORDEM_PLANEJADA', selected: false },
    { label: 'Ordem executada', value: 'VISITA_ORDEM_EXECUTADA', selected: false },
    { label: 'Tempo de atendimento planejado', value: 'VISITA_TEMPO_ATENDIMENTO_PLANEJADO', selected: false },
    { label: 'Tempo de atendimento executado', value: 'VISITA_TEMPO_ATENDIMENTO_EXECUTADO', selected: false },
    { label: 'Tempo de percurso planejado da visita', value: 'VISITA_TEMPO_PERCURSO_PLANEJADO', selected: false },
    { label: 'Tempo de percurso executado da visita', value: 'VISITA_TEMPO_PERCURSO_EXECUTADO', selected: false },
    { label: 'Distância planejada da visita', value: 'VISITA_DISTANCIA_PLANEJADO', selected: false },
    { label: 'Distância executada da visita', value: 'VISITA_DISTANCIA_EXECUTADO', selected: false },
    { label: 'Custo Planejado de Visita', value: 'VISITA_CUSTO_PLANEJADO', selected: false },
    { label: 'Custo Executado de Visita', value: 'VISITA_CUSTO_EXECUTADO', selected: false },

    // Campos de serviços
    { label: 'Tipo de serviço', value: 'SERVICO_TIPO', selected: false },
    { label: 'Código do serviço', value: 'SERVICO_CODIGO', selected: false },
    { label: 'Cubagem do serviço', value: 'SERVICO_CUBAGEM', selected: false },
    { label: 'Peso do serviço', value: 'SERVICO_PESO', selected: false },
    { label: 'Valor do serviço', value: 'SERVICO_VALOR', selected: false },
    { label: 'Volume do serviço', value: 'SERVICO_VOLUME', selected: false },
    { label: 'Número do serviço', value: 'SERVICO_NUMERO', selected: false },
    { label: 'Documento do serviço', value: 'SERVICO_DOCUMENTO', selected: false },
    { label: 'Razão social do serviço', value: 'SERVICO_RAZAO_SOCIAL', selected: false },
    { label: 'Nome fantasia do serviço', value: 'SERVICO_NOME_FANTASIA', selected: false },
    { label: 'Status do serviço', value: 'SERVICO_STATUS', selected: false },
    { label: 'Prioridade do serviço', value: 'SERVICO_PRIORIDADE', selected: false },
    { label: 'Início planejado do serviço', value: 'SERVICO_INICIO_PLANEJADO', selected: false },
    { label: 'Início executado do serviço', value: 'SERVICO_INICIO_EXECUTADO', selected: false },
    { label: 'Fim planejado do serviço', value: 'SERVICO_FIM_PLANEJADO', selected: false },
    { label: 'Fim executado do serviço', value: 'SERVICO_FIM_EXECUTADO', selected: false },
];

export const listaFilds = [
    "ROTA_INICIO",
    "ROTA_FIM",
    "ROTA_DATA",
    "ROTA_NOME",
    "ROTA_IDENTIFICADOR",
    "ROTA_TIPO_VEICULO",
    "ROTA_PLACA",
    "ROTA_NOME_MOTORISTA",
    "ROTA_ATIVA",
    "ROTA_TEM_ESCOLTA",
    "ROTA_PERMITE_CARGA_EXPRESSA",
    "ROTA_PESO",
    "ROTA_VOLUME",
    "ROTA_CUBAGEM",
    "ROTA_VALOR",
    "ROTA_DISTANCIA_PLANEJADA",
    "ROTA_DISTANCIA_EXECUTADA",
    "ROTA_TEMPO_PLANEJADO",
    "ROTA_TEMPO_EXECUTADO",
    "ROTA_POIS_PLANEJADOS",
    "ROTA_POIS_EXECUTADOS",
    "ROTA_VISITAS_ADIADAS",
    "ROTA_VISITAS_ADICIONADAS",
    "ROTA_VISITAS_CANCELADAS",
    "ROTA_VISITAS_OCORRENCIA",
    "ROTA_VISITAS_PENDENTES",
    "ROTA_VISITAS_SUCESSO",
    "VISITA_CODIGO",
    "VISITA_LATITUDE",
    "VISITA_LONGITUDE",
    "VISITA_CLIENTE",
    "VISITA_STATUS",
    "VISITA_TEMPO_PARADA",
    "VISITA_DIFERENCA_CHEGADA",
    "VISITA_DIFERENCA_PARTIDA",
    "VISITA_TIPO",
    "VISITA_ENDERECO",
    "VISITA_CARGA_EXPRESSA",
    "VISITA_ALTO_VALOR_AGREGADO",
    "VISITA_FILIAL",
    "VISITA_CHEGADA_PLANEJADA",
    "VISITA_CHEGADA_EXECUTADA",
    "VISITA_PARTIDA_PLANEJADA",
    "VISITA_PARTIDA_EXECUTADA",
    "VISITA_ORDEM_PLANEJADA",
    "VISITA_ORDEM_EXECUTADA",
    "VISITA_TEMPO_ATENDIMENTO_PLANEJADO",
    "VISITA_TEMPO_ATENDIMENTO_EXECUTADO",
    "VISITA_TEMPO_PERCURSO_PLANEJADO",
    "VISITA_TEMPO_PERCURSO_EXECUTADO",
    "VISITA_DISTANCIA_PLANEJADO",
    "VISITA_DISTANCIA_EXECUTADO",
    "SERVICO_TIPO",
    "SERVICO_CODIGO",
    "SERVICO_CUBAGEM",
    "SERVICO_PESO",
    "SERVICO_VALOR",
    "SERVICO_VOLUME",
    "SERVICO_NUMERO",
    "SERVICO_DOCUMENTO",
    "SERVICO_RAZAO_SOCIAL",
    "SERVICO_NOME_FANTASIA",
    "SERVICO_STATUS",
    "SERVICO_PRIORIDADE",
    "SERVICO_INICIO_PLANEJADO",
    "SERVICO_INICIO_EXECUTADO",
    "SERVICO_FIM_PLANEJADO",
    "SERVICO_FIM_EXECUTADO",
];
